import { Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";

import { type ChatChannelCustomTypesFilter } from "../types";
import { ChatListFilterTabs } from "./FilterTabs";
import { ChatListSearchBar } from "./SearchBar";

interface ChatListHeaderProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  filterType: ChatChannelCustomTypesFilter;
  onFilterTypeChange: (type: ChatChannelCustomTypesFilter) => void;
}

export function ChatListHeader(props: ChatListHeaderProps) {
  const { searchValue, onSearchChange, filterType, onFilterTypeChange } = props;

  return (
    <Box sx={{ position: "sticky", top: 0, zIndex: 1 }}>
      <Stack
        direction="column"
        spacing={4}
        sx={{
          padding: 5,
          paddingBottom: 3,
        }}
      >
        <Text semibold variant="h4">
          Clipboard Chat
        </Text>

        <ChatListSearchBar value={searchValue} onChange={onSearchChange} />

        <ChatListFilterTabs filterType={filterType} onFilterTypeChange={onFilterTypeChange} />
      </Stack>
    </Box>
  );
}
